module.exports = "/dist/assets/images/Munch-logo-white.svg";